module.exports = __webpack_public_path__ + "static/media/companyLogo4.2f4a336f.png";